import { useCallback, useEffect, useState } from "react";

import { useClientOnly } from "@/util/ClientOnly.jsx";

export default function useMediaQuery(query: string): boolean | null {
  if (typeof matchMedia !== "function") {
    return null;
  }

  const isHydrated = useClientOnly();

  // So we can use `mobile` and `tablet` imports from clutch.
  query = query.replace(/^@media /, "");

  const [result, setResult] = useState(() => matchMedia(query).matches);

  const updateMediaQuery = useCallback(
    function (result: MediaQueryListEvent) {
      return setResult(result.matches);
    },
    [setResult],
  );

  useEffect(() => {
    const result = matchMedia(query);

    setResult(result.matches);

    result.addEventListener("change", updateMediaQuery);

    return function () {
      return result.removeEventListener("change", updateMediaQuery);
    };
  }, [query, setResult]);

  if (!isHydrated) {
    return null;
  }

  return result;
}
